export const DEFAULT_FONT_SIZES = {
  home_text: 16,
  home_info_icon: 16,
  home_info_text: 12,
  home_button_text: 14,
  finish_survey_text: 14,
  question_text: 18,
  gender_label: 10,
  input_text: 16,
  option_text: 16,
  option_icon: 16,
  other_text: 14,
  other_text_remaining: 10,
  image_option_text: 16,
  image_option_icon: 16,
  nps_score: 16,
  nps_description: 14,
  dial_code_text: 10,
  consent_text: 14,
  consent_icon: 18,
  icon_lable: 10,
  tile_text: 16,
  thankyou_text: 18,
  openended_text: 14,
  openended_remaining_text: 14,
  quiz_score_text: 40,
  quiz_score_label: 14,
  media_button_icon: 20,
  media_other_text_icon: 22,
  progress_bar_text: "15",
  progress_bar: "22",
  description_text: 16,
  description_heading_text: 20,
  table_text: 16,
};

const defaultFont = "Arial";

export const DEFAULT_FONT_STYLES = {
  home_text: defaultFont,
  home_info_icon: defaultFont,
  home_info_text: defaultFont,
  home_button_text: defaultFont,
  finish_survey_text: defaultFont,
  question_text: defaultFont,
  gender_label: defaultFont,
  input_text: defaultFont,
  option_text: defaultFont,
  option_icon: defaultFont,
  other_text: defaultFont,
  other_text_remaining: defaultFont,
  image_option_text: defaultFont,
  image_option_icon: defaultFont,
  nps_score: defaultFont,
  nps_description: defaultFont,
  dial_code_text: defaultFont,
  consent_text: defaultFont,
  consent_icon: defaultFont,
  icon_lable: defaultFont,
  tile_text: defaultFont,
  thankyou_text: defaultFont,
  openended_text: defaultFont,
  openended_remaining_text: defaultFont,
  quiz_score_text: defaultFont,
  description_text: defaultFont,
  description_heading_text: defaultFont,
  table_text: defaultFont,
};
